import API from "@/api/API";

/**
 * Product add-ons the company's subscription grants (exportCapabilitiesEnabled,
 * exportThreeDModelEnabled, aiInspectionEnabled, airteamDesignerEnabled, ...).
 *
 * They restrict customers only — employees work across companies and always see
 * the full toolset. Anything we could not resolve stays permitted: a failed or
 * skipped fetch (anonymous share links, a company with no v2 subscription) must
 * never silently strip a feature the user had yesterday.
 *
 * Sample projects are the exception: they fetch with failClosed, so an
 * unresolved fetch denies every add-on. A sample is a read-only showcase, so
 * denying there can never strip a feature from the customer's own projects.
 */
const state = {
  addons: {},
  allDenied: false,
  loaded: false,
};

const getters = {
  subscriptionAddonsLoaded: (state) => state.loaded,
  addonEnabled: (state, getters) => (key) => {
    if (getters.activeUserIsEmployee) return true;
    if (state.allDenied) return false;
    return state.addons[key] !== false;
  },
};

const mutations = {
  setSubscriptionAddons(state, addons) {
    state.addons = addons || {};
    state.allDenied = false;
    state.loaded = true;
  },
  denyAllSubscriptionAddons(state) {
    state.addons = {};
    state.allDenied = true;
    state.loaded = true;
  },
};

const actions = {
  // Never rejects: the viewer must still load when the subscription does not.
  async fetchSubscriptionAddons({ commit }, { companyId, failClosed = false }) {
    if (!companyId) {
      if (failClosed) {
        console.error(
          "Subscription add-ons unresolved: no company id; all add-ons denied."
        );
        commit("denyAllSubscriptionAddons");
      }
      return;
    }
    try {
      const { data } = await API.subscriptions.getCompanyAddons(companyId);
      commit("setSubscriptionAddons", data || {});
    } catch (err) {
      if (failClosed) {
        console.error(
          `Subscription add-ons unresolved for company ${companyId}; all add-ons denied.`,
          err
        );
        commit("denyAllSubscriptionAddons");
        return;
      }
      console.error(
        `Subscription add-ons unresolved for company ${companyId}; all add-ons permitted.`,
        err
      );
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
